import {WithWidth} from '@material-ui/core/withWidth';

export default (width: WithWidth) => ['xs', 'sm', 'md'].includes(width.width);
